<app-page class="small">
  <ng-template #head>
    <ng-container [ngTemplateOutlet]="expo_template"></ng-container>
    <ng-container [ngTemplateOutlet]="info_template"></ng-container>
    <ng-container [ngTemplateOutlet]="obje_template"></ng-container>
    <ng-container [ngTemplateOutlet]="meth_template"></ng-container>
    <ng-container [ngTemplateOutlet]="insi_template"></ng-container>
    <ng-container [ngTemplateOutlet]="exhi_template"></ng-container>
    <ng-container [ngTemplateOutlet]="impa_template"></ng-container>
  </ng-template>
</app-page>

<app-page class="medium">
  <ng-template #head>
    <ng-container [ngTemplateOutlet]="expo_template"></ng-container>
    <ng-container [ngTemplateOutlet]="info_template"></ng-container>
  </ng-template>
  <ng-template #col1>
    <ng-container [ngTemplateOutlet]="obje_template"></ng-container>
    <ng-container [ngTemplateOutlet]="meth_template"></ng-container>
    <ng-container [ngTemplateOutlet]="insi_template"></ng-container>
  </ng-template>
  <ng-template #col2>
    <ng-container [ngTemplateOutlet]="exhi_template"></ng-container>
    <ng-container [ngTemplateOutlet]="impa_template"></ng-container>
  </ng-template>
</app-page>

<app-page class="large head-left">
  <ng-template #head>
    <ng-container [ngTemplateOutlet]="expo_template"></ng-container>
    </ng-template>
  <ng-template #col1>
    <ng-container [ngTemplateOutlet]="obje_template"></ng-container>
    <ng-container [ngTemplateOutlet]="insi_template"></ng-container>
  </ng-template>
  <ng-template #col2>
    <ng-container [ngTemplateOutlet]="meth_template"></ng-container>
    <ng-container [ngTemplateOutlet]="impa_template"></ng-container>
  </ng-template>
  <ng-template #col3>
    <ng-container [ngTemplateOutlet]="info_template"></ng-container>
    <ng-container [ngTemplateOutlet]="exhi_template"></ng-container>
  </ng-template>
</app-page>

<ng-template #expo_template>
  <app-card [content]="exposition"></app-card>
</ng-template>

<ng-template #info_template>
  <app-card [content]="information"></app-card>
</ng-template>

<ng-template #obje_template>
  <app-card [content]="objective"></app-card>
</ng-template>

<ng-template #meth_template>
  <app-card [content]="methods"></app-card>
</ng-template>

<ng-template #insi_template>
  <app-card [content]="insights"></app-card>
</ng-template>

<ng-template #impa_template>
  <app-card [content]="impact"></app-card>
</ng-template>

<ng-template #exhi_template>
  <app-card [content]="exhibition"></app-card>
</ng-template>
